import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Chip
} from '@mui/material';
import {
  Menu as MenuIcon,
  AccountCircle,
  Logout,
  Search,
  Keyboard
} from '@mui/icons-material';
import GlobalSearch from './GlobalSearch';
import ThemeToggle from './ThemeToggle';
import { simpleAuth } from '../services/simpleAuth';

const Header = ({ onLogout, user, onMenuClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchOpen, setSearchOpen] = React.useState(false);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    onLogout();
  };

  // Global search keyboard shortcut
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
        <AppBar position="fixed" sx={{
      zIndex: (theme) => theme.zIndex.drawer + 1,
      top: 0,
      left: 0,
      right: 0,
      height: { xs: '56px', sm: '64px' },
      backgroundColor: 'rgba(26, 26, 26, 0.95)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(102, 126, 234, 0.2)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
    }}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        
        <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              fontSize: '1.25rem',
              fontWeight: 'bold'
            }}
          >
            Social Media Enhancement Tool
          </Typography>
          {simpleAuth.forceRefreshCompanyName() && (
            <Typography 
              variant="body2" 
              component="div" 
              sx={{ 
                color: 'text.secondary',
                fontSize: '0.875rem'
              }}
            >
              {simpleAuth.forceRefreshCompanyName()}
            </Typography>
          )}
        </Box>
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            flexGrow: 1,
            fontSize: '1rem',
            display: { xs: 'block', sm: 'none' }
          }}
        >
          SMET
        </Typography>
        
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
            {/* Theme Toggle */}
            <ThemeToggle />
            
            {/* Global Search Button */}
            <IconButton
              onClick={() => setSearchOpen(true)}
              sx={{ 
                color: 'text.secondary',
                '&:hover': {
                  color: 'text.primary',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)'
                }
              }}
            >
              <Search />
            </IconButton>
            
            <Chip
              icon={<Keyboard />}
              label="⌘K"
              size="small"
              sx={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                color: 'text.secondary',
                fontSize: '12px',
                height: 24,
                display: { xs: 'none', sm: 'flex' }
              }}
            />
            
            <Typography 
              variant="body2" 
              sx={{ 
                mr: { xs: 1, sm: 2 },
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                display: { xs: 'none', sm: 'block' }
              }}
            >
              Welcome, {user?.user_metadata?.full_name || 
                        user?.user_metadata?.name || 
                        user?.email?.split('@')[0] || 
                        'User'}
            </Typography>
          
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
            sx={{ 
              minWidth: { xs: 40, sm: 48 },
              minHeight: { xs: 40, sm: 48 }
            }}
          >
            <Avatar sx={{ width: { xs: 28, sm: 32 }, height: { xs: 28, sm: 32 } }}>
              <AccountCircle />
            </Avatar>
          </IconButton>
          
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleClose}>Settings</MenuItem>
            <MenuItem onClick={handleLogout}>
              <Logout sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
    
    {/* Global Search Dialog */}
    <GlobalSearch 
      open={searchOpen} 
      onClose={() => setSearchOpen(false)} 
    />
  </>
  );
};

export default Header;
